import { styled } from '@mui/material/styles'

export const PayoutReportsFiltersRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  zIndex: 10,
  '& .react-select__control': {
    borderRadius: 10,
    borderColor: theme.palette.divider,
    minHeight: 40,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .react-select__control--is-focused': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
  },
}))
